import { useSyncExternalStore } from 'react';
import { Input } from './Input';
import { captureStore } from './store';
import { CaptureUi } from './CaptureUi';

interface InputCaptureProps {
  showUi?: boolean;
}

interface InputCaptureProps {
  showUi?: boolean;
  skipGamepad?: boolean;
}

export const InputCapture = (props: InputCaptureProps) => {
  const access = useSyncExternalStore(captureStore.subscribeAccess, captureStore.getAccess);
  const { showUi = false, skipGamepad = false } = props;

  return (
    <>
      <Input {...access} skipGamepad={skipGamepad} />
      {showUi ? <CaptureUi /> : null}
    </>
  );
};
